// extracted by mini-css-extract-plugin
export default {"npsScale":"Nps_npsScale__3kbbp","npsScaleSelected":"Nps_npsScaleSelected__-i7d5","logo":"Nps_logo__Hhb8t"};